"use client";

import { useEffect } from "react";
import { getFcmToken } from "@/lib/permissions/notification";
import { getDeviceInfo } from "@/lib/device/getDeviceInfo";
import { registerFcm } from "@/actions/register-fcm.action";
import { useNotification } from "@/hooks/notification/useNotification";
import { logger } from "@/lib/logger";

/**
 * Initialize browser notification support and register the current device FCM token.
 * @returns `null` because this provider does not render UI
 */
export function FcmProvider() {
  useNotification();

  useEffect(() => {
    /**
     * Get the current browser FCM token and send it to the backend with device info.
     */
    const registerToken = async () => {
      const deviceInfo = getDeviceInfo();
      const fcmToken = await getFcmToken();

      logger.log("[FCM] fcmToken:", fcmToken);

      if (!fcmToken) {
        return;
      }

      // Register FCM token to the api
      const response = await registerFcm({ fcmToken, ...deviceInfo });

      if (!response.success) {
        logger.error("[FCM] failed to register token:", response.message);
      }
    };

    void registerToken();
  }, []);

  return null;
}
